import React from "react";
import { useLocation } from "react-router-dom";
import ProjectGallery from "Parts/ProjectGallery/ProjectGallery";
import { projectDataSummary } from "data";
import "./PortfolioPage.css";
import type { ProjectType } from "types";
import { Fade } from "motion";
import { Text } from "foundation";
import { capitalise } from "utilities";
import { Flex } from "@chakra-ui/react";

const PortfolioPage: React.FC = () => {
  const location = useLocation();
  const page: string = location.pathname.slice(1);

  return (
    <Fade>
      <Flex
        width="full"
        justify="center"
        align="center"
        height={{ base: "20vh", md: "40vh" }}
        padding={{ base: "1rem", sm: "1.5rem", md: "2rem" }}
      >
        <Text textStyle="h1">{capitalise(page)}</Text>
      </Flex>
      <ProjectGallery
        projects={projectDataSummary.filter((project) =>
          project.type.includes(page as ProjectType)
        )}
      />
    </Fade>
  );
};

export default PortfolioPage;
